import { Dispatch, SetStateAction, createContext } from "react";
import { IVoiceTimer } from "@interfaces/voicecall/voicecall";

export type IVoiceCallContext = {
    time: IVoiceTimer | undefined, 
    showTimer: boolean,
    expired: boolean,
    counterIsAllowed: boolean,
    setCounterIsAllowed?: Dispatch<SetStateAction<boolean>>,
    resetStates: () => void
}

const defaultVoiceCallData: IVoiceCallContext = {
    time: undefined,
    expired: false,
    showTimer: false,
    counterIsAllowed: false,
    resetStates: () => { console.debug("Default reset state"); }
};

export const VoiceCallContext = createContext<IVoiceCallContext>(defaultVoiceCallData);
